export const PROFESSIONAL_USE_LABEL =
  'I am a dental professional, or purchasing for a dental practice or laboratory, and will use this product within its intended indications.';
